"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CitationsSources: ()=>CitationsSources
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const handleClick = ({ setIsOpened, isOpened })=>function(event) {
        event.preventDefault();
        event.stopPropagation();
        setIsOpened(!isOpened);
    };
const CitationsSources = (props)=>{
    const [isOpened, setIsOpened] = (0, external_react_namespaceObject.useState)(false);
    const { webSearchResult } = props;
    const numberOfCitations = webSearchResult.length;
    const chipProps = {
        fontWeight: 'bold',
        label: 'Sources',
        facet: `(${numberOfCitations})`,
        Icon: external_pcln_icons_namespaceObject.Globe,
        expanded: isOpened,
        showActionIcon: true
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ButtonChip, {
                ...chipProps,
                size: "sm",
                my: 1,
                onClick: handleClick({
                    isOpened,
                    setIsOpened
                })
            }),
            isOpened && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                children: webSearchResult.map((result, index)=>{
                    const url = new URL(result.url);
                    const host = url.host;
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                            fontSize: 0,
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text.span, {
                                    children: [
                                        result.citationNumber,
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Link, {
                                    href: result.url,
                                    target: "_blank",
                                    children: result.webPageName
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                                    ml: 1,
                                    color: "text.light",
                                    children: host
                                })
                            ]
                        })
                    }, `Web-search-res-${index}`);
                })
            })
        ]
    });
};
CitationsSources.displayName = 'CitationsSources';
exports.CitationsSources = __webpack_exports__.CitationsSources;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CitationsSources"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
